import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { switchMembershipModalSelector } from 'admin/state/modules/members/selectors';
import SwitchMembershipModal from "admin/views/members/switch-membership-modal";
import { authUserSelector, screenWidthSelector, siteInfoSelector } from 'admin/state/modules/common/selectors';
import { openCloseSwitchMembershipConfirmModalAction, openCloseSwitchMembershipModalAction, updateSwitchMembershipMembersDataAction } from 'admin/state/modules/members/actions';
import SwitchMembershipConfirmModals from 'admin/views/members/switch-membership-modal/modules/confirm-modals';
import { checkIfCanSwitchMembershipOperation, checkIsSubscribedToNewMembershipAndSwitchOperation, switchMembershipOperation } from 'admin/state/modules/members/operations';
import QueryParams from 'admin/utils/QueryParams';

const CONFIRM_MODAL_TYPES_OPEN_ON_CONTAINER = ['unable_to_switch', 'no_members_to_switch']

class SwitchMembershipContainer extends Component {
   static propTypes = {
      switchMembershipModal: PropTypes.object,
      screenWidth: PropTypes.number,
      openCloseSwitchMembershipModal: PropTypes.func,
      openCloseSwitchMembershipConfirmModal: PropTypes.func,
      checkIfCanSwitchMembership: PropTypes.func,
      authUser: PropTypes.object,
      checkIsSubscribedToNewMembershipAndSwitch: PropTypes.func,
      switchMembership: PropTypes.func,
      updateSwitchMembershipMembersData: PropTypes.func,
      siteInfo: PropTypes.object,
   }

   componentDidMount(){
      if(QueryParams.getParam('modal') === 'change-membership') {
         QueryParams.removeQueryParam('modal')
      }
   }


   render(){
      const {
         switchMembershipModal,
         screenWidth,
         openCloseSwitchMembershipModal,
         openCloseSwitchMembershipConfirmModal,
         checkIfCanSwitchMembership,
         authUser,
         checkIsSubscribedToNewMembershipAndSwitch,
         switchMembership,
         updateSwitchMembershipMembersData,
         siteInfo,
      } = this.props;

      return (
         <>
            {
               switchMembershipModal?.isOpen && (
                  <SwitchMembershipModal
                     onCloseModal={ () => openCloseSwitchMembershipModal() }
                     isMobile={ screenWidth <= 1024 }
                     membersData={ switchMembershipModal.membersData }
                     isFetchingSwitchMembership={ switchMembershipModal.isFetchingSwitchMembership }
                     confirmModal={ switchMembershipModal.confirmModal }
                     openCloseConfirmModal={ openCloseSwitchMembershipConfirmModal }
                     confirmModalTypesOpenOnContainer={ CONFIRM_MODAL_TYPES_OPEN_ON_CONTAINER }
                     checkIfCanSwitchMembership={ checkIfCanSwitchMembership }
                     authUser={ authUser }
                     checkIsSubscribedToNewMembershipAndSwitch={ checkIsSubscribedToNewMembershipAndSwitch }
                     switchToNewMembership={ switchMembership }
                     updateSwitchMembershipMembersData={ updateSwitchMembershipMembersData }
                     isDemoMode={ 'demo_mode' === siteInfo?.site_status }
                  />
               )
            }
            {
               switchMembershipModal.confirmModal.isOpen && CONFIRM_MODAL_TYPES_OPEN_ON_CONTAINER.includes(switchMembershipModal.confirmModal.type) && (
                  <SwitchMembershipConfirmModals
                     type={ switchMembershipModal.confirmModal.type }
                     isMobile={ screenWidth <= 1024 }
                     onConfirm={ () => openCloseSwitchMembershipConfirmModal(null) }
                     onCloseModal={ () => openCloseSwitchMembershipConfirmModal(null) }
                  />
               )
            }
         </>
      );
   }

}

const mapStateToProps = (state) => {
   return {
      switchMembershipModal: switchMembershipModalSelector(state),
      screenWidth: screenWidthSelector(state),
      authUser: authUserSelector(state),
      siteInfo: siteInfoSelector(state),
   }
}

const mapDispatchToProps = (dispatch) => {
   return {
      openCloseSwitchMembershipModal: () => dispatch(openCloseSwitchMembershipModalAction()),
      openCloseSwitchMembershipConfirmModal: (type, additionalInfo) => dispatch(openCloseSwitchMembershipConfirmModalAction(type, additionalInfo)),
      checkIfCanSwitchMembership: (successCallback, cannotSwitchCallback) => dispatch(checkIfCanSwitchMembershipOperation(successCallback, cannotSwitchCallback)),
      checkIsSubscribedToNewMembershipAndSwitch: (payload) => dispatch(checkIsSubscribedToNewMembershipAndSwitchOperation(payload)),
      switchMembership: (payload) => dispatch(switchMembershipOperation(payload)),
      updateSwitchMembershipMembersData: (membersData) => dispatch(updateSwitchMembershipMembersDataAction(membersData)),
   }
}


export default connect(mapStateToProps, mapDispatchToProps)(SwitchMembershipContainer);
